const KnownHumanChromosomes = Array.apply(null, Array(22))
  .map((k, i) => (i + 1).toString())
  .concat("X", "Y");

export default KnownHumanChromosomes;
